import React from 'react';

export const ClosingCall = () => {
  return <div>ClosingCall</div>;
};
